Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCommitmentStateCompleted = void 0;
var _models = require("../../models");
var isCommitmentStateCompleted = exports.isCommitmentStateCompleted = function isCommitmentStateCompleted(state) {
  if (!state) return false;
  return [_models.CommitmentState.successful, _models.CommitmentState.existing].includes(state);
};